import {} from "@mui/material";

import OperatorTableContainer from "../../../shared/OperatorsList/OperatorsTableContainer";
import { useNavigate } from "react-router-dom";
const operators = [
  {
    id: "123213",
    name: "Мельниченко Вадим",
    hours: 2,
    received: 12,
    withHelp: 10,
    crosses: 0,
    bonus: 5550,
    percentBonus: 83.33,
    avgCheck: 482.5,
    leadsPerHour: 6.0,
  },
  {
    id: "123223",
    name: "Оксанич Катерина",
    hours: 5,
    received: 8,
    withHelp: 7,
    crosses: 1,
    bonus: 3200,
    percentBonus: 78.5,
    avgCheck: 400,
    leadsPerHour: 4.5,
  },
  {
    id: "1333213",
    name: "Грекова Наталя",
    hours: 7,
    received: 15,
    withHelp: 12,
    crosses: 2,
    bonus: 6000,
    percentBonus: 80,
    avgCheck: 500,
    leadsPerHour: 5.0,
  },
  {
    id: "111111",
    name: "Сакунова Євгенія",
    hours: 13,
    received: 20,
    withHelp: 18,
    crosses: 0,
    bonus: 7500,
    percentBonus: 90,
    avgCheck: 550,
    leadsPerHour: 6.5,
  },
  {
    id: "12ewwe",
    name: "Сидоренко Світлана",
    hours: 4,
    received: 10,
    withHelp: 9,
    crosses: 0,
    bonus: 4200,
    percentBonus: 85,
    avgCheck: 480,
    leadsPerHour: 5.2,
  },
];
export default function OperatorsTableList() {
  const navigate = useNavigate();
  return (
    <OperatorTableContainer
      operators={operators}
      onNavigate={(id) => navigate(`/management/operator/${id}`)}
      onAdd={() => navigate("/management/add-new-user")}
    />
  );
}
